module.exports = {"component":"time-picker","status":"prod","display-name":"Timepickers","SLDS-component-path":"/components/timepicker","url-slug":"timepickers"}


//////////////////
// WEBPACK FOOTER
// ./components/time-picker/docs.json
// module id = 330
// module chunks = 0